export default __webpack_public_path__ + "static/media/live.8a8ef610.gif";